<div class="mb-3">
    <div class="table-header fw-bold py-2 d-flex flex-row flex-nowrap">
        <div class="col-2 col-lg-1 px-2" translate="CONFIRMATION_PARTICIPANTLIST_TITLE_LABEL"></div>
        <div class="col px-2" translate="CONFIRMATION_PARTICIPANTLIST_FIRSTNAME_LABEL"></div>
        <div class="col px-2" translate="CONFIRMATION_PARTICIPANTLIST_LASTNAME_LABEL"></div>
        <div class="d-none d-lg-block col px-2" translate="CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL"></div>
        @if (displayMobileNumber) {
            <div class="d-none d-lg-block col px-2" translate="CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL"></div>
        }
    </div>
    @if (participants.length > 0) {
        @for (participant of participants; track participant) {
            <div class="table-row py-2">
                <div class="d-flex flex-row">
                    <div class="col-2 col-lg-1 px-2">{{ participant.title.value }}</div>
                    <div class="col px-2">{{ participant.firstName.value }}</div>
                    <div class="col px-2">{{ participant.lastName.value }}</div>
                    <div class="d-none d-lg-block col px-2">{{ participant.mail.value }}</div>
                    @if (displayMobileNumber) {
                        <div class="d-none d-lg-block col px-2">
                            {{ participant.mobileNumber.value }}
                        </div>
                    }
                </div>
                <div class="d-block d-lg-none col-12 my-1">
                    <label
                        class="col-4 px-2 col-form-label"
                        translate="CONFIRMATION_PARTICIPANTLIST_EMAIL_LABEL"
                    ></label>
                    <div class="col-8 px-2">
                        <span class="form-control-plaintext">{{ participant.mail.value }}</span>
                    </div>
                    @if (displayMobileNumber) {
                        <label
                            class="col-4 px-2 col-form-label"
                            translate="CONFIRMATION_PARTICIPANTLIST_MOBILE_NUMBER_LABEL"
                        ></label>
                    }
                    @if (displayMobileNumber) {
                        <div class="col-8 px-2">
                            <span class="form-control-plaintext">{{ participant.mobileNumber.value }}</span>
                        </div>
                    }
                </div>
            </div>
        }
    }
    @if (participants.length === 0) {
        <div class="table-row py-2">
            <div class="d-flex flex-row">
                <label class="col px-2" translate="CONFIRMATION_SUMMARY_PARTICIPANT_NOT_AVAILABLE"></label>
            </div>
        </div>
    }
</div>
